import { FC, useContext } from 'react';
import { Carousel } from 'react-responsive-carousel';
import { ListOfGalleryId } from '../types';
import { blobPath, cdnUrl } from '../constants';

interface CarouselMainProps {
  listOfGalleryId: ListOfGalleryId[];
}

const CarouselMain: FC<CarouselMainProps> = ({ listOfGalleryId, ...props }) => {
  return (
    <Carousel
      showThumbs={false}
      showIndicators={false}
      showStatus={false}
      autoPlay={true}
      interval={6000}
      infiniteLoop={true}
      showArrows={true}
    >
      {listOfGalleryId.map((item, index) => (
        <img src={cdnUrl + blobPath + item.code} alt={item.alt} key={index} />
      ))}
    </Carousel>
  );
};

export default CarouselMain;
